import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { useGetIntakeFormConfigurationQuery } from '../store/api';

import {
  hasStaffRole,
  type IntakeReminderVariant,
  isIntakeReminderHiddenOnPath,
  resolveIntakeReminder,
} from './intakeReminder';

/**
 * Null until the user's intake configuration is known, so the chrome never
 * jumps. The submit mutation invalidates this query, so no polling is needed.
 *
 * The configuration is the signed-in provider's own, so it is never requested
 * where the reminder cannot show: inside the hub, on staff routes, or for a
 * staff identity (the way the hub skips it for its admin context).
 */
export function useIntakeReminder(): IntakeReminderVariant | null {
  const { pathname } = useLocation();
  const { user, isLoading: isAuthLoading } = useAuth0();
  const hidden =
    isIntakeReminderHiddenOnPath(pathname) ||
    isAuthLoading ||
    hasStaffRole(user?.['https://api.smartscribe.health/roles']);
  const { currentData } = useGetIntakeFormConfigurationQuery(undefined, { skip: hidden });
  return hidden ? null : resolveIntakeReminder(currentData);
}
